import React, {
	FC,
	ChangeEvent,
	Fragment,
	useState,
	FocusEvent,
	forwardRef,
	Ref,
} from 'react'
import InputLabel from '@mui/material/InputLabel'
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material'
import EyeOpenSvg from '../../assets/eye_open.svg'
import EyeCloseSvg from '../../assets/eye_close.svg'

interface IInputPasswordProps {
	id: string
	label?: string
	name?: string
	autoComplete?: string
	placeholder?: string
	value?: string
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void
	onBlur?: (event: FocusEvent<HTMLInputElement>) => void
	onFocus?: (event: FocusEvent<HTMLInputElement>) => void
	color?:
		| 'primary'
		| 'secondary'
		| 'error'
		| 'info'
		| 'success'
		| 'warning'
		| undefined
	error?: boolean
}

const InputPassword: FC<IInputPasswordProps> = forwardRef(
	(
		{
			id,
			name,
			label,
			autoComplete,
			placeholder,
			onChange,
			value,
			color,
			onFocus,
			onBlur,
		}: IInputPasswordProps,
		ref: Ref<HTMLDivElement>
	) => {
		const [showPassword, setShowPassword] = useState<boolean>(false)

		const handleClickShowPassword = (
			e: React.MouseEvent<HTMLButtonElement>
		): void => {
			e.stopPropagation()
			setShowPassword(!showPassword)
		}

		const eyeIconSrc = showPassword ? EyeOpenSvg : EyeCloseSvg

		return (
			<Fragment>
				<InputLabel shrink htmlFor={id}>
					{label}
				</InputLabel>
				<OutlinedInput
					id={id}
					name={name}
					type={showPassword ? 'text' : 'password'}
					autoComplete={autoComplete}
					placeholder={placeholder}
					onChange={onChange}
					onFocus={onFocus}
					onBlur={onBlur}
					value={value}
					ref={ref}
					color={color}
					endAdornment={
						<InputAdornment position='end'>
							<IconButton onClick={handleClickShowPassword} edge='end' disableRipple>
								<img
									src={eyeIconSrc}
									alt={'hide or show password'}
									style={{ width: '2.625rem' }}
								/>
							</IconButton>
						</InputAdornment>
					}
				/>
			</Fragment>
		)
	}
)

InputPassword.displayName = 'InputPassword'

export default InputPassword
